import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";
import { generateParamsFromObj } from "@/common/utils";
import { PaginatedResponse, Quote } from "@/common/types";

const getMultiSiteResults = async (
  multiQuoteId: string,
  filters: any,
  searchQ: string
) => {
  const params = generateParamsFromObj(filters);
  const searchFields = ["lastMileProvider", "manufaturerName", "provider"];
  searchFields.forEach((el) => params.append("searchFields", el));
  params.append("searchQ", searchQ);
  params.append("id", multiQuoteId);
  return await axiosInstance
    .get(`req/quotes/multi/results/${multiQuoteId}`, { params })
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useGetMultiSiteResults = (
  multiQuoteId: string,
  filters: any,
  searchQ: string
) => {
  return useQuery<PaginatedResponse<Quote>>({
    queryKey: ["multiQuote", multiQuoteId, filters, searchQ],
    queryFn: () => getMultiSiteResults(multiQuoteId, filters, searchQ),
    enabled: multiQuoteId !== "0",
  });
};
export default useGetMultiSiteResults;
